import { makeStyles } from "@material-ui/core/styles";

export const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 1,
};

// Higher to the right, lower to the left
const INITIAL_RIGHT = 85;
const FAB_TOGGLE_CHANGE_BG_IMG_RIGHT = INITIAL_RIGHT + 50 * 4;
const FAB_TOGGLE_ALL_RIGHT = INITIAL_RIGHT + 50 * 3;
const FAB_ADD_BAND_RIGHT = INITIAL_RIGHT + 50 * 2;
const FAB_RESTORE_RIGHT = INITIAL_RIGHT + 50 * 1;
const FAB_CANCEL_RIGHT = INITIAL_RIGHT;

const newSolutionFilterBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 100,
  gap: 4,
  border: "1px solid white",
  padding: "3px",
  textAlign: "center",
  cursor: "pointer",
  borderRadius: 3,
  color: "white",
  "&:hover": {
    transform: "scale(1.05)",
  },
};

export const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: "100%",
    width: "100%",
    backgroundSize: "cover",
    position: "relative",
  },
  opaqueBackground: {
    height: "100%",
    width: "100%",
    padding: "10px 15px",
    overflowY: "auto",
    backgroundColor: `#FFFFFF33`,
    [theme.breakpoints.up("md")]: {
      paddingBottom: 120,
    },
  },
  titleContainer: {
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  homeFilters: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    flexDirection: "column",
    // [theme.breakpoints.up("md")]: {
    //   position: "absolute",
    //   top: 10,
    //   right: 15,
    // },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1),
    },
  },
  formControl: {
    minWidth: 120,
  },
  comboSolution: {
    padding: 3,
    color: "white",
    backgroundColor: `${theme.palette.content.mainColor}AA`,
    borderRadius: 10,
    border: "1px solid white",
    textAlign: "center",
  },
  comboSolutionIcon: {
    fill: "white",
  },
  comboSolutionSelect: {
    paddingRight: "12px !important",
  },
  solutionsComboContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    width: "100%",
    marginBottom: "20px",
  },
  solutionsComboLabel: {
    marginRight: 8,
    color: "white",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  gridBandEditing: {
    position: "relative",
    border: `2px dashed #FFFFFF`,
    borderRadius: 5,
  },
  fab: {
    position: "absolute",
    bottom: 15,
    right: 15,
    zIndex: 1,
    backgroundColor: theme.palette.home.fabMainBg,
    color: "#FFFFFF",
    width: 60,
    height: 60,
    "&:hover": {
      backgroundColor: theme.palette.home.fabMainBg,
      color: "#FFFFFF",
      transform: "scale(1.1)",
    },
  },
  fabRestore: {
    color: "#FFFFFF",
    right: FAB_RESTORE_RIGHT,
    bottom: "22px",
    zIndex: "1",
    position: "absolute",
    backgroundColor: "grey",
    width: 40,
    height: 40,
    "&:hover": {
      backgroundColor: `grey`,
      color: "#FFFFFF",
      transform: "scale(1.1)",
    },
  },
  fabCancel: {
    color: "#FFFFFF",
    right: FAB_CANCEL_RIGHT,
    bottom: "22px",
    zIndex: "1",
    position: "absolute",
    backgroundColor: "grey",
    width: 40,
    height: 40,
    "&:hover": {
      backgroundColor: `grey`,
      color: "#FFFFFF",
      transform: "scale(1.1)",
    },
  },
  fabAddBand: {
    color: "#FFFFFF",
    right: FAB_ADD_BAND_RIGHT,
    bottom: "22px",
    zIndex: "1",
    position: "absolute",
    backgroundColor: "grey",
    width: 40,
    height: 40,
    "&:hover": {
      backgroundColor: "grey",
      color: "#FFFFFF",
      transform: "scale(1.1)",
    },
  },
  fabToggleAll: {
    color: "#FFFFFF",
    right: FAB_TOGGLE_ALL_RIGHT,
    bottom: "22px",
    zIndex: "1",
    position: "absolute",
    backgroundColor: "grey",
    width: 40,
    height: 40,
    "&:hover": {
      backgroundColor: "grey",
      color: "#FFFFFF",
      transform: "scale(1.1)",
    },
  },
  fabChangeBgImg: {
    color: "#FFFFFF",
    right: FAB_TOGGLE_CHANGE_BG_IMG_RIGHT,
    bottom: "22px",
    zIndex: "1",
    position: "absolute",
    backgroundColor: "grey",
    width: 40,
    height: 40,
    "&:hover": {
      backgroundColor: "grey",
      color: "#FFFFFF",
      transform: "scale(1.1)",
    },
  },
  imgIconHome: {
    width: 28,
  },
  imgIconHome42: {
    width: 42,
  },
  customTypoLabel: {
    fontSize: "0.6rem",
  },
  imageListContainer: {
    right: 20,
    bottom: 90,
    display: "flex",
    overflow: "hidden",
    position: "absolute",
    flexWrap: "wrap",
    maxWidth: 900,
    justifyContent: "space-around",
    backgroundColor: "transparent",
    padding: 5,
  },
  imageListContainerInner: {
    overflowX: "hidden",
    whiteSpace: "nowrap",
    position: "relative",
  },
  imageList: {
    flexWrap: "nowrap",
    transform: "translateZ(0)",
    overflow: "scroll",
  },
  imageListItem: {
    cursor: "pointer",
    position: "relative",
  },
  selectedBgImg: {
    position: "relative",
    border: `6px solid ${theme.palette?.semaphore?.red}`,
  },
  bgImg: {
    position: "relative",
    // border: `1px solid #FFF`,
  },
  typoBgImgTagName: {
    position: "absolute",
    bottom: 10,
    right: 10,
    backgroundColor: "white",
    borderRadius: 50,
    color: `darkslategrey`,
    fontWeight: "bold",
    padding: 5,
    width: 55,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navigationButtonLeft: {
    top: "50%",
    position: "absolute",
    transform: "translateY(-50%)",
    backgroundColor: "#FFF",
    left: "10px",
    zIndex: 1,
    color: "#000000",
    "&:hover": {
      backgroundColor: "#FFF",
      color: "#000000",
    },
  },
  navigationButtonRight: {
    top: "50%",
    position: "absolute",
    transform: "translateY(-50%)",
    backgroundColor: "#FFF",
    right: "10px",
    color: "#000000",
    zIndex: 1,
    "&:hover": {
      backgroundColor: "#FFF",
      color: "#000000",
    },
  },
  solutionComboImage: {
    maxWidth: 30,
    marginRight: 7,
  },
  newSolutionsFilterContainer: {
    display: "flex",
    gap: "8px",
  },
  newSolutionFilter: {
    ...newSolutionFilterBase,
    backgroundColor: "grey",
  },
  newSolutionFilterSelected: {
    ...newSolutionFilterBase,
    backgroundColor: "#2FBC78",
  },
  loadnOnDemandBtn: {
    marginLeft: "12px",
    padding: "6px",
    backgroundColor: "white",
    color: theme.palette.semaphore.green,
    width: 35,
    height: 35,
    "&:hover": {
      backgroundColor: "white",
      color: theme.palette.semaphore.green,
      transform: "scale(1.03)"
    },
  },
}));
